export const PREMATCH_REQUEST_PAYLOAD_FIELDS = [
  'matchId',
  'tournamentStageId',
  'tournamentId',
  'tournamentUnionId',
  'sportId',
];

export const PREMATCH_REQUEST_PAYLOAD_FIELD_CATEGORIES = {
  matchId: 'match',
  tournamentStageId: 'stage',
  tournamentId: 'tournament',
  tournamentUnionId: 'union',
  sportId: 'sport',
};

export enum Category {
  Sport = 1,
  Union = 2,
  Tournament = 3,
  Stage = 4,
  Match = 5,
}

export const ALL_MATCHES = 'all-matches';
export const MATCHES_WITH_FAVOURITES = 'with-favorites';
export const MATCHES_WITH_MY_STAKES = 'with-my-stakes';
export const MATCHES_WITH_MY_TEAMS = 'with-my-teams';

